import c from "../common"

export default {

    //Column
    "ApplicationNumber": "Request ID",
    "ShopID": "Shop ID",

    "VendorName":c.vendor.en.uppercase+" Name",
    "VendorPhone": c.vendor.en.uppercase+" Phone Number",
    "TicketName": "Ticket Name",

    "isGroupAdmin":"Group Admin", 
    "Progress": "Progress",

    "Processing":"Processing",
    "Approved": "Approved",
    "Reject": "Reject",
    "Cancelled": "Cancelled",
    "Expired": "Expired",

    "NeedResubmit":"Need Resubmit",

    "LastEdit":"Last Edit",

    "ApplicationList":"Application List",

    "Detail": "Detail",

    "LogOut": "LogOut",

    "issueRequest": "Issue",
    "updateRequest": "Update",
};